import { useVerifyUserSolana } from 'shared/hooks/use-verify-user-solana'

/** Keeps logged-in user wallet address in sync with the connected Solana wallet. */
export const VerifyUserEffect = () => {
  useVerifyUserSolana()
  return null
}
